import { useCallback, useMemo } from 'react'
import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-community'
import { intl } from '../../../../i18n'
import { RoleRow, roleRowService } from '../model/RoleRow'

type UseContextMenuProps = {
  addRowAction: () => void
  deleteRowAction: (uuids: string[]) => void
}

export const useContextMenu = ({
  addRowAction,
  deleteRowAction,
}: UseContextMenuProps) => {
  const getContextMenuItems = useCallback(
    (params: GetContextMenuItemsParams<RoleRow>): (string | MenuItemDef)[] => {
      const selectedNodes = params.api?.getSelectedNodes() || []
      const selectedUuids = selectedNodes
        .map(node => node.data?.uuid)
        .filter((uuid): uuid is string => !!uuid)

      const canDelete =
        selectedUuids.length > 0 &&
        selectedNodes.every(
          node => node.data && roleRowService.isDeletable(node.data)
        )

      return [
        {
          name: intl.formatMessage({ id: 'roles.contextMenu.addRow' }),
          action: () => addRowAction(),
        },
        {
          name: intl.formatMessage({ id: 'roles.contextMenu.deleteRow' }),
          action: () => deleteRowAction(selectedUuids),
          disabled: !canDelete,
        },
      ]
    },
    [addRowAction, deleteRowAction]
  )

  return useMemo(
    () => ({
      getContextMenuItems,
    }),
    [getContextMenuItems]
  )
}
